import { parseHtml, twClassMerge } from '@healthhub/react-ui';
import { Modal } from 'antd';

import { Button } from '@shared/components';

interface InfoModalProps {
  className?: string;
  closeText: string;
  content: string;
  hideFooterDivider?: boolean;
  imageClassName?: string;
  img?: string;
  onClick: () => void;
  show: boolean;
  title?: string;
  width?: number | string;
}

const InfoModal = ({
  className,
  closeText,
  content,
  imageClassName,
  img,
  onClick,
  show,
  title,
  width,
  hideFooterDivider = false,
}: InfoModalProps) => (
  <Modal
    centered
    className={twClassMerge(
      '[&_.ant-modal-footer]:mt-0 [&_.ant-modal-footer]:px-4 [&_.ant-modal-footer]:py-2.5',
      hideFooterDivider
        ? '[&_.ant-modal-footer]:border-t-0 [&_.ant-modal-footer]:p-0'
        : '[&_.ant-modal-footer]:border-t [&_.ant-modal-footer]:border-solid [&_.ant-modal-footer]:border-primary-grey',
      className
    )}
    closable={false}
    footer={[
      <div
        className={twClassMerge('flex justify-center', hideFooterDivider ? 'px-4 py-0 pb-4' : 'p-4')}
        key="Info modal close button"
      >
        <Button className="w-full" onClick={onClick} variant="primary">
          {closeText}
        </Button>
      </div>,
    ]}
    onOk={onClick}
    open={show}
    title={title || ''}
    width={width}
  >
    <div className="flex flex-col items-center">
      {!!img && <img alt="" className={imageClassName} src={img} />}
      <div className="text-center">{parseHtml(content)}</div>
    </div>
  </Modal>
);

export default InfoModal;
